<script lang="ts" setup>
const emit = defineEmits<{
  (e: "refresh"): void;
}>();
</script>

<template>
  <UiFormWishes
    @refresh="emit('refresh')"
  />
</template>
